import React, { useState } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import { RichText } from '../assets/components';

function ExpansionControl({ ...rest }) {
  const { expansionControlClasses, switchExpansion } = rest;
  return <i className={expansionControlClasses} onClick={switchExpansion} />;
}

function RelatedSDGControl({ ...rest }) {
  const { relatedSDGButtonClasses } = rest;
  return <i className={relatedSDGButtonClasses} />;
}

export function ConstructingTheFuture({ data, ...rest }) {
  const [expansion, setExpansion] = useState(false);
  const { attributes } = data;

  const {
    className,
    tagName: Tag,
    blockClass,
    category,
    tagline,
    content,
    buttonText,
    buttonClassOpened,
    buttonClassClosed,
    relatedSDGControlClass,
    url,
    prefix,
  } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  const innerWrapClasses = classnames(`${prefix}__wrap`, {});

  const categoryClasses = classnames(`${prefix}__category`, {});

  const taglineClasses = classnames(`${prefix}__tagline`, {});

  const contentClasses = classnames(`${prefix}__paragraph`, {});

  const buttonClasses = classnames(`${prefix}__button`, {});

  const expansionControlClasses = classnames(`${prefix}__expansion-control`, {
    [buttonClassOpened]: !expansion,
    [buttonClassClosed]: expansion,
  });

  const relatedSDGButtonClasses = classnames(`${prefix}__related-sdgs-button`, {
    [relatedSDGControlClass]: true,
  });

  const style = url ? { backgroundImage: `url(${url})` } : {};

  const switchExpansion = () => setExpansion(!expansion);

  return (
    <>
      <Tag className={blockClasses} style={style}>
        <CSSTransition in={expansion} timeout={500} classNames="expansion" appear={true}>
          <div className={innerWrapClasses} onDoubleClick={switchExpansion}>
            <RichText className={categoryClasses} tagName="h7" value={category} />
            <RichText className={taglineClasses} tagName="h3" value={tagline} />
            <RichText className={contentClasses} tagName="p" value={content} />
            <RichText className={buttonClasses} tagName="h7" value={buttonText} />
            <ExpansionControl
              expansionControlClasses={expansionControlClasses}
              switchExpansion={switchExpansion}
            />
            <RelatedSDGControl relatedSDGButtonClasses={relatedSDGButtonClasses} />
          </div>
        </CSSTransition>
      </Tag>
    </>
  );
}
